export default __webpack_public_path__ + "static/Beginnings-4b2386071f73e7b57c7295d67b5197de.png";